import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import TeaserPersonOverlay from "../../../teaser-base/person/teaser-person-overlay";
import ErrorBoundary from "../../../../error-boundary";

/**
 * Usually the first module on a person page - person intro module with most
 * important information.
 */
const ParagraphPersonInformation = ({ nodeContent }) => {
  const sectionClassNames = classNames({
    "paragraph paragraph-person-information": true,
  });

  return (
    <section className={sectionClassNames}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-11 offset-md-1">
            <ErrorBoundary>
              <TeaserPersonOverlay item={nodeContent} />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </section>
  );
};

ParagraphPersonInformation.propTypes = {
  viewMode: PropTypes.string,
  nodeContent: PropTypes.shape({}),
};

export default ParagraphPersonInformation;
